import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import { CheckBox } from 'Components/common/CheckBox';
import Button from 'Components/common/Button';
import RadioButton from 'Components/common/RadioBtn';
import './teamMembersDropdown.scss';

const DropdownOption = props => {
  const {
    selectedTeamMembers,
    setSelectedTeamMembers,
    teamMemberLimit,
    setError,
    setActiveRadio,
    ...remainingProps
  } = props;

  const isSelected = selectedTeamMembers.some(
    member => member.memberId === props.memberId,
  );
  const isNameNotAvailable =
    !remainingProps.firstName && !remainingProps.lastName;

  const valueOfName = isNameNotAvailable
    ? remainingProps.emailId
    : `${remainingProps.firstName || ''} ${remainingProps.lastName || ''}`;
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li
      className={`option${
        remainingProps.status === 'INACTIVE' ? ' inactive' : ''
      }`}
      onClick={() => {
        if (isSelected) {
          setSelectedTeamMembers(
            selectedTeamMembers.filter(
              member => member.memberId !== props.memberId,
            ),
          );
          setActiveRadio('');
        } else if (selectedTeamMembers.length < teamMemberLimit) {
          setSelectedTeamMembers([...selectedTeamMembers, remainingProps]);
          setActiveRadio('');
        } else if (selectedTeamMembers.length === teamMemberLimit) {
          setError(
            `You can select a maximum of ${teamMemberLimit} team members at a time`,
          );
        }
      }}
    >
      <CheckBox dymamicClass={isSelected ? 'selected' : ''} />
      <div className="option-text">
        <div className="name" title={valueOfName}>
          {valueOfName}
        </div>
        {!isNameNotAvailable && (
          <div className="email" title={remainingProps.emailId}>
            {remainingProps.emailId}
          </div>
        )}
      </div>
      {remainingProps.status === 'INACTIVE' && (
        <span className="status-badge">
          {remainingProps.status.toLowerCase()}
        </span>
      )}
    </li>
  );
};

const TeamMembersDropdown = props => {
  const {
    onClose,
    onApply,
    teamMembers,
    selectedTeamMembers: defaultValue,
    teamMemberLimit,
  } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTeamMembers, setSelectedTeamMembers] = useState(defaultValue);
  const [error, setError] = useState('');
  const [activeRadio, setActiveRadio] = useState('');
  const searchMatch = new RegExp(searchTerm, 'ig');

  useEffect(() => {
    if (error !== '')
      setTimeout(() => {
        setError('');
      }, 3500);
  }, [error]);

  const activeUsers = teamMembers.filter(member => member.status === 'ACTIVE');

  return (
    <div className="team-members-dropdown">
      <div className="search-wrapper">
        <input
          placeholder="Search user by name or email"
          onChange={e => setSearchTerm(e.target.value)}
        />
        <SearchIcon />
      </div>
      <div className="dropdown-options">
        <i className="text">
          You can select a maximum of {teamMemberLimit} users.
        </i>
        <ul className="option-list">
          {teamMembers
            .filter(
              member =>
                member.emailId.match(searchMatch) ||
                member.firstName.match(searchMatch) ||
                member.lastName.match(searchMatch),
            )
            .map((teamMember, index) => {
              return (
                <DropdownOption
                  {...teamMember}
                  key={`${teamMember.emailId}-${index}`}
                  setError={setError}
                  setActiveRadio={setActiveRadio}
                  teamMemberLimit={teamMemberLimit}
                  selectedTeamMembers={selectedTeamMembers}
                  setSelectedTeamMembers={setSelectedTeamMembers}
                />
              );
            })}
        </ul>
      </div>
      <div className="radio-wrapper">
        <RadioButton
          id="active-user"
          label="All Active Users"
          value="All Active Users"
          onChange={() => {
            if (activeUsers.length > teamMemberLimit) {
              setError(
                `You can select a maximum of ${teamMemberLimit} team members at a time`,
              );
            } else {
              setSelectedTeamMembers(activeUsers);
              setActiveRadio('ACTIVE');
            }
          }}
          checked={activeRadio === 'ACTIVE'}
        />
        <RadioButton
          id="all-user"
          label="All Users"
          value="All Users"
          onChange={() => {
            if (teamMembers.length > teamMemberLimit) {
              setError(
                `You can select a maximum of ${teamMemberLimit} team members at a time`,
              );
            } else {
              setSelectedTeamMembers(teamMembers);
              setActiveRadio('ALL');
            }
          }}
          checked={activeRadio === 'ALL'}
        />
      </div>
      <div className="button-wrapper">
        <Button
          className="cancel"
          btnText="cancel"
          click={e => {
            e.stopPropagation();
            onClose();
          }}
        />
        <Button
          className="apply"
          btnText="Apply"
          click={e => {
            e.stopPropagation();
            onClose();
            onApply(selectedTeamMembers);
          }}
        />
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default TeamMembersDropdown;
